module.exports = __webpack_public_path__ + "img/kangaroo.3883f4ca.gif";